export const headerConfig = {
  headerTitle: 'e - Credentials',
  headerDescription: 'List of e - Credentials',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
